import {
	getCommissionAmount,
	getTicketFinancial,
	isSendInvoice,
	parseInvoiceTotalNumeric,
} from "./financialDisplay";

/** @param {Tickets_Object[]} tickets */
export const calculateWeeklySummary = (tickets) => {
	let nonInvoicedTotal = 0;
	let billedCount = 0;
	let totalCommission = 0;

	tickets.forEach((ticket) => {
		const financial = getTicketFinancial(ticket);
		if (!financial?.pkey) return;
		if (isSendInvoice(financial.payment_type)) return;

		nonInvoicedTotal += parseInvoiceTotalNumeric(financial);
		billedCount += 1;
		totalCommission += getCommissionAmount(financial);
	});

	const avgBilled =
		billedCount > 0 ? nonInvoicedTotal / billedCount : 0;
	const avgCommissionPerWo =
		billedCount > 0 ? totalCommission / billedCount : 0;

	return {
		nonInvoicedTotal,
		billedCount,
		totalCommission,
		avgBilled,
		avgCommissionPerWo,
	};
};

/** @param {Tickets_Object[]} tickets */
export const calculateSuggestedFuelCredits = (tickets) => {
	if (!tickets?.length) return 0;
	// Incomplete tickets (no financials), free revisits (type 3 with $0 labor),
	// and send-invoice jobs do not earn travel/fuel credits.
	// Revisits with nonzero labor are billable and do earn a fuel credit.
	return tickets.filter((ticket) => {
		const financial = getTicketFinancial(ticket);
		if (!financial?.pkey) return false;
		if (isSendInvoice(financial.payment_type)) return false;
		if (ticket.type === 3) {
			const labor = parseFloat(financial.labor_amount) || 0;
			return labor !== 0;
		}
		return true;
	}).length;
};

/** @param {number} avgBilled @param {number} billedCount */
export const shouldSuggestBonus = (avgBilled, billedCount) =>
	avgBilled > 200 && billedCount > 15;

/** @param {number} billedCount @param {number} feWorkOrderAmount */
export const calculateDefaultEstimatedDays = (billedCount, feWorkOrderAmount) => {
	const divisor = feWorkOrderAmount || 4;
	if (!billedCount) return 0;
	return Math.round((billedCount / divisor) * 10) / 10;
};
